import React from 'react';

export const IconBin = () => (
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Icon / Bin</title>
    <g id="ABS---Agencija-za-bezbednost" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="Policijska-uprava-/-Tehnicki-pregledi/-Osnovne-informacije"
        transform="translate(-741.000000, -284.000000)"
        fill="#2C2C2C"
        fill-rule="nonzero"
      >
        <g id="Shape" transform="translate(741.000000, 284.000000)">
          <path d="M2.994,3.81642974 L3.51440001,10.8550711 L8.6112,10.8550711 L9.13120001,3.81642974 L10.3332,3.81642974 L9.80800001,10.9355978 C9.76369693,11.5351033 9.24110169,11.9998857 8.6112,12 L3.51440001,12 C2.88435477,11.9998716 2.36170317,11.5348724 2.31760001,10.9352161 L1.7916,3.81642974 L2.994,3.81642974 Z M5.60600001,4.17097605 L5.60600001,9.51397768 L4.40600001,9.51397768 L4.40600001,4.17097605 L5.60600001,4.17097605 Z M7.8,4.17097605 L7.8,9.51397768 L6.6,9.51397768 L6.6,4.17097605 L7.8,4.17097605 Z M0,1.90821487 L12,1.90821487 L12,3.05314379 L0,3.05314379 L0,1.90821487 Z M8.50280001,0 L8.50280001,1.14492892 L3.70280001,1.14492892 L3.70280001,0 L8.50280001,0 Z"></path>
        </g>
      </g>
    </g>
  </svg>
);
